// Production traffic goes through the same HTTPS Nginx origin and prefix.
// Development keeps the direct backend target for local work.
export const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/yuqing'
  : 'http://120.26.12.90:9683'
